/**
 * 해당 파일에서 export 된 요소들에 대한 상세 설명은 아래 gatsby-browser API 에 포함되어 있습니다.
 * https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from 'react';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import { GatsbyBrowser } from 'gatsby';

import '@kakaopay-web-ui/components/css';
import '@kakaopay-web-ui/template/css';
import WithShowSecBridge from './src/components/common/WithShowSecBridge';
import { initMSW } from './src/configs/mock';
import { queryClient } from './src/configs/query';
import { RootErrorBoundary } from './src/errors/boundaries/RootErrorBoundary';
import { isMock } from './src/utils/appInfo';
import { initSentry } from './src/utils/sentry';

import '~/assets/styles/base.scss';

/**
 * Gatsby 최상위 컴포넌트
 * app 전체에 적용할 Provider 를 추가하는 곳으로 권장됨
 * */
export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => {
  (async () => {
    initSentry();
  })();

  if (isMock) {
    initMSW();
  }

  return (
    <RootErrorBoundary>
      <QueryClientProvider client={queryClient}>
        {element}
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      </QueryClientProvider>
    </RootErrorBoundary>
  );
};

/**
 * page 를 이동해도 unmount 되지 않는 wrapper component
 * 공통적으로 적용될 style 등을 설정할 곳으로 권장됨
 * */
export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
}) => {
  return <WithShowSecBridge>{element}</WithShowSecBridge>;
};
